import type { ReactNode } from 'react';
import { BrowserRouter, NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth.js';
import { Billing } from './routes/Billing.js';
import { Dashboard } from './routes/Dashboard.js';
import { History } from './routes/History.js';
import { Login } from './routes/Login.js';
import { Settings } from './routes/Settings.js';

const RequireAuth = ({ children }: { children: ReactNode }) => {
  const { me, loading } = useAuth();
  if (loading) return <main className="page">Loading workspace…</main>;
  if (!me) return <Navigate to="/login" replace />;
  return <>{children}</>;
};

const Nav = () => {
  const { me } = useAuth();
  if (!me) return null;
  return (
    <nav className="topbar">
      <div className="topbar-inner">
        <div className="brand">
          <span className="brand-mark">AI</span>
          <span>AI Trading</span>
        </div>
        <div className="nav-links">
          <NavLink className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`} to="/">
            Dashboard
          </NavLink>
          <NavLink
            className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
            to="/history"
          >
            History
          </NavLink>
          <NavLink
            className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
            to="/settings"
          >
            Settings
          </NavLink>
          <NavLink
            className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
            to="/billing"
          >
            Billing
          </NavLink>
        </div>
      </div>
    </nav>
  );
};

export const App = () => (
  <BrowserRouter>
    <div className="app-shell">
      <Nav />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />
        <Route
          path="/settings"
          element={
            <RequireAuth>
              <Settings />
            </RequireAuth>
          }
        />
        <Route
          path="/billing"
          element={
            <RequireAuth>
              <Billing />
            </RequireAuth>
          }
        />
        <Route
          path="/history"
          element={
            <RequireAuth>
              <History />
            </RequireAuth>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  </BrowserRouter>
);
